import { render, staticRenderFns } from "./FaqAndSupportDesktop.vue?vue&type=template&id=d8faa722&scoped=true"
import script from "./FaqAndSupportDesktop.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportDesktop.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportDesktop.vue?vue&type=style&index=0&id=d8faa722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8faa722",
  null
  
)

export default component.exports